module.exports = __webpack_public_path__ + "static/media/level-six.9e360951.svg";